import { Injectable } from "@angular/core";

@Injectable({
	providedIn: "root",
})
export class LazyLoadService {
	static readonly DEFAULT_MARGIN = "300px 0px";

	private observers: IntersectionObserver[] = [];

	observeElement(
		element: HTMLElement,
		callback: () => void,
		rootMargin: string = LazyLoadService.DEFAULT_MARGIN
	): void {
		const observer = new IntersectionObserver(
			(entries, obs) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						callback();
						obs.disconnect();
					}
				});
			},
			{ rootMargin }
		);

		observer.observe(element);
		this.observers.push(observer);
	}

	disconnectAll(): void {
		this.observers.forEach((observer) => observer.disconnect());
		this.observers = [];
	}
}
